module.exports = __webpack_public_path__ + "media/images/country_flags/bw-507d3bf187c5f8e975afddf91a42607b.png";